export const checkIsAdminMedical = user => {
    if (user && user.roleObj && user.roleObj.id === 1) return true
    return false
}


// WEBPACK FOOTER //
// ./src/helper/mission.js